import { IRest } from "./rest.interface";

export class PublicStatistics implements IRest {
    className = 'Estatísticas Públicas';

    plans!: number;
    subjects!: number;
    topics!: number;
    plannings!: number;
    studies!: number;
    durationStudiesWeek!: number;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            plans: this.plans,
            subjects: this.subjects,
            topics: this.topics,
            plannings: this.plannings,
            studies: this.studies,
            durationStudiesWeek: (this.durationStudiesWeek * 3600)
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.plans = data['plans'] || 0;
            this.subjects = data['subjects'] || 0;
            this.topics = data['topics'] || 0;
            this.plannings = data['plannings'] || 0;
            this.studies = data['studies'] || 0;
            this.durationStudiesWeek = Math.round((data['durationStudiesWeek'] || 0) / 3600);
        }
        return this;
    }

}